







































import { Size } from '@front-app/components/constants';
import { computed, defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
	props: {
		isMember: Boolean,
		isRegistered: Boolean,
		isAdmin: Boolean,
		isInvitee: Boolean,
		isPast: Boolean,
		isDot: Boolean,
		size: {
			type: String as PropType<Size>,
			default: Size.TINY,
		},
	},
	setup(props) {
		const classes = computed(() => ({
			'badge--past': props.isPast,
			'badge--tiny': props.size === Size.TINY,
			'badge--medium': props.size === Size.MEDIUM,
			'badge--is-dot': props.isDot,
		}));
		return {
			classes,
		};
	},
});
